<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self" @reload="$reloadHandle"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="tree-box fl">
					<div class="tit" @click="clearNodeClick"><b>机构分类</b></div>
					<el-tree
						:props="defaultProps"
						:load="loadNode"
						node-key="id"
						ref="tree"
						highlight-current
						lazy
						:expand-on-click-node="false"
						@node-click="handleNodeClick"
						class="tree-list"
						icon-class="el-icon-arrow-down"
					></el-tree>
				</div>
				<label id="labBtn">
					<div class="icon">
						<i class="el-icon-more"></i>
						<i class="el-icon-more"></i>
					</div>
				</label>
				<div class="main-right fr" style="padding-left:6px;">
					<div class="grid-height">
						<vxe-grid
							id="table-m1"
							ref="table-m1"
							:auto-resize="true"
							v-bind="vxeOption"
							@resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle"
						>
							<template #form>
								<div class="clearfix screen-btns">
									<div class="fl">
										<!-- <vxe-button status="success" class="button-sty button-add" icon="el-icon-circle-plus-outline" @click="openEditDialog">新增</vxe-button> -->
										<vxe-button status="primary" class="button-sty" icon="el-icon-plus" @click="openEditDialog">新增</vxe-button>
									</div>
									<div class="fr">
										<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary" plain>重置</vxe-button>

										<vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
									</div>
								</div>
								<vxe-form ref="searchForm" class="screen-box" :data="formData" title-width="92px" title-align="right">
									<vxe-form-item title="机构名称:" field="saleOrgName">
										<template v-slot>
											<el-input v-model="formData.saleOrgName" size="small" :disabled="true"></el-input>
										</template>
									</vxe-form-item>
									<vxe-form-item title="登录名:" field="loginAccount">
										<template v-slot>
											<el-input v-model="formData.loginAccount" size="small" clearable></el-input>
										</template>
									</vxe-form-item>
									<vxe-form-item title="手机号:" field="mobile">
										<template v-slot>
											<el-input v-model="formData.mobile" size="small" clearable></el-input>
										</template>
									</vxe-form-item>
									<vxe-form-item title="是否启用:" field="enabled">
										<template v-slot>
											<el-select v-model="formData.enabled" clearable>
												<el-option value="true" label="启用"></el-option>
												<el-option value="false" label="禁用"></el-option>
											</el-select>
										</template>
									</vxe-form-item>
								</vxe-form>
							</template>
						</vxe-grid>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue';
import { treeScollx } from '@/utils/global.js';
export default {
	name: 'user:list',
	components: {
		editView
	},
	created() {},
	activated() {
		// this.initTableList();
	},
	mounted() {
		treeScollx({ target: this, type: 'default' });
		this.initTableList();
	},
	data() {
		return {
			showEdit: false,
			activeName: 'second',
			showUpload: true,
			uploadSize: 10,
			value10: '',
			dataId: '',
			tp: false,
			showUserDialog: false,
			nickName: 'dd',
			formData: {
				userType: 0
			},
			vxeOption: {
				className: 'list-table'
			},
			defaultProps: {
				label: 'name', //这里是树结构中需显示的数据（即接口返回的需展示在页面上的参数）
				children: [],
				isLeaf: 'leaf'
			}
		};
	},
	methods: {
		searchEvent() {
			this.$refs['table-m1'].commitProxy('reload');
		},
		resetEvent() {
			this.formData = {
				userType: 0
			};
			this.$refs.tree.setCurrentKey();
			this.$refs['table-m1'].commitProxy('reload');
		},
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
		clearNodeClick() {
			this.formData.saleOrgId = '';
			this.formData.saleOrgName = '';
			this.$refs.tree.setCurrentKey();
			this.searchEvent();
		},
		handleNodeClick(data, node, v) {
			this.$set(this.formData, 'saleOrgId', data.id);
			this.$set(this.formData, 'saleOrgName', data.name);
			this.$forceUpdate();
			this.searchEvent();
		},
		// 异步树叶子节点懒加载逻辑
		loadNode(node, resolve) {
			let id = node && node.data && node.data.id ? node.data.id || '' : '';
			let param = { enabled: true };
			let url = !id ? USER_PREFIX + '/sale_org/getAllList' : USER_PREFIX + '/sale_org/getChildren';
			this.$http({
				url: url,
				method: 'post',
				data: {
					parent: id,
					enabled: true
				},
				success: res => {
					res.objx.forEach(value => {
						value.leaf = !value.hasChild;
					});
					if (node.level === 0) {
						if (res.objx.length > 0 && res.objx[0].isParent) {
							this.$nextTick(() => {
								let nodedata = node.childNodes[0];
								nodedata.expanded = true;
								nodedata.loadData();
							});
						}
					}
					resolve(res.objx);
				}
			});
		},
		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_user_list-m1',
				path: USER_PREFIX + '/user/listAllPage',

				param: () => {
					return this.formData;
				},
				columns: [
					{
						type: 'checkbox',
						width: 48,
						resizable: false,
						fixed: 'left'
					},
					{
						title: '登录名',
						field: 'loginAccount',
						width: 250,
						fixed: 'left'
					},
					{
						field: 'nickName',
						title: '姓名',
						width: 150
					},
					{
						field: 'mobile',
						title: '手机号',
						width: 150
					},
					{
						field: 'enabled',
						title: '是否启用',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.enabled) {
									return [<div class="txt-status">启用</div>];
								} else {
									return [<div class="txt-status s-3">禁用</div>];
								}
							}
						}
					},
					{
						field: 'birth',
						title: '出生日期',
						width: 150,
						slots: {
							default: ({ row }) => {
								var val = row.birth;
								if (val) {
									return val.substring(0, 10);
								}
							}
						}
					},
					{
						field: 'zipCode',
						title: '邮编',
						width: 150
					},
					{
						field: 'address',
						title: '地址',
						width: 150
					},
					{
						field: 'gender',
						title: '性别',
						width: 150,
						slots: {
							default: ({ row }) => {
								var val = row.gender;
								if (val == 1) {
									return '男';
								} else if (val == 2) {
									return '女';
								}
							}
						}
					},
					{
						field: 'createBy',
						title: '创建人',
						width: 150
					},
					{
						field: 'modifyBy',
						title: '更新人',
						width: 150
					},
					{
						field: 'modifyDate',
						title: '更新时间',
						width: 150
					},
					{
						field: 'createDate',
						title: '创建时间',
						width: 150
					},
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<a
										href="javascript:void(0);"
										class="a-link"
										onclick={() => {
											this.openEditDialog(row.id);
										}}
									>
										<el-tooltip enterable={false} enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
											<i class="el-icon-edit" />
										</el-tooltip>
									</a>
								];
							}
						}
					}
				]
			};
			this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
				this.vxeOption = opts;
			});
		},
		importExcel() {
			let that = this;
			that.$excelImport({
				prefix: USER_PREFIX,
				excel: USER_PREFIX + '/excelTemplate/user/user.xlsx',
				multi: true,
				saveUrl: USER_PREFIX + '/user/batchImport',
				callback: () => {
					that.searchEvent();
				}
			});
		}
	}
};
</script>
